import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './composingCorrectionMessages';
import ActionButton from './ComposingCorrectionAnswerListActionButton';

import './ComposingCorrectionAnswerList.scss';

const ComposingCorrectionAnswerList = (props) => (
  <div className="card correction-answer-list">
    {props.totalWarning > 0 && (
      <div className="card-header">
        <FormattedMessage {...messages.problemsFound}>
          {(txt) => (
            <div className="card-header-title">
              <i className="ti-alert" /> {txt}
            </div>
          )}
        </FormattedMessage>
        <span className="badge-status">{props.totalWarning}</span>
      </div>
    )}
    <div className="card-body">
      {props.students.map((student) => (
        <div className="card-item">
          <div className="card-item-label">
            <p>
              {student.registration} - {student.studentName}
            </p>
          </div>
          <div className="card-item-details">
            {student.hasEssayUpload && (
              <span className="essay-uploaded">
                <FormattedMessage {...messages.essayUploaded} />
              </span>
            )}
            <ActionButton {...student} onUpload={() => props.onUpload(student)} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

ComposingCorrectionAnswerList.propTypes = {};

ComposingCorrectionAnswerList.defaultProps = {
  students: [],
};
export default ComposingCorrectionAnswerList;
